import React, { useEffect } from "react";
import { motion } from "framer-motion";

const mkLine = (delay) => ({
  hidden: { y: "110%", opacity: 0 },
  show: {
    y: "0%",
    opacity: 1,
    transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1], delay },
  },
});

const descVariants = {
  hidden: { opacity: 0, y: 24, filter: "blur(6px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.55 },
  },
};

const tagVariants = {
  hidden: { opacity: 0, x: -12 },
  show:   { opacity: 1, x: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 0.05 } },
};

const ruleVariants = {
  hidden: { scaleX: 0 },
  show:   { scaleX: 1, transition: { duration: 1.0, ease: [0.16, 1, 0.3, 1], delay: 0.2 } },
};

const statVariants = (delay) => ({
  hidden: { opacity: 0, y: 20 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1], delay } },
});

export default function AboutUsSection({ registerIntent }) {
  useEffect(() => {
    if (registerIntent) registerIntent(() => false);
  }, [registerIntent]);

  return (
    <section className="about-section">
      <div className="about-section__glow about-section__glow--1" />
      <div className="about-section__glow about-section__glow--2" />

      <motion.div
        className="about-section__content"
        initial="hidden"
        animate="show"
      >
        {/* Tag */}
        {/* <motion.div className="about-section__tag" variants={tagVariants}>
          <span className="about-section__tag-dot" />
          About Us
        </motion.div> */}

        {/* Rule */}
        <motion.div className="about-section__rule" variants={ruleVariants} />

        {/* Title */}
        <h2 className="about-section__title">
          <span className="about-section__line-clip">
            <motion.span className="about-section__line-inner" variants={mkLine(0.1)}>
              WE DESIGN —&nbsp;<em>DIGITAL</em>
            </motion.span>
          </span>
          <span className="about-section__line-clip">
            <motion.span className="about-section__line-inner" variants={mkLine(0.22)}>
              <em>EXPERIENCES</em>&nbsp;FOR
            </motion.span>
          </span>
          <span className="about-section__line-clip">
            <motion.span className="about-section__line-inner" variants={mkLine(0.34)}>
              MODERN BUSINESSES
            </motion.span>
          </span>
        </h2>

        {/* Description */}
        <motion.p className="about-section__desc" variants={descVariants}>
          ExD Digital is an AI-first technology company building scalable
          software, automation, and digital experiences that drive growth.
        </motion.p>

        {/* Stats */}
        <div className="about-section__stats">
          {[
            { value: "15+",  label: "Years Experience",   delay: 0.65 },
            { value: "200+", label: "Projects Delivered", delay: 0.75 },
            { value: "50+",  label: "Global Clients",     delay: 0.85 },
          ].map((s) => (
            <motion.div
              key={s.label}
              className="about-section__stat"
              variants={statVariants(s.delay)}
            >
              <span className="about-section__stat-value">{s.value}</span>
              <span className="about-section__stat-label">{s.label}</span>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}